import { Button } from "@icg360/design-system";

import { IS_IMPERSONATED } from "data/ss-data-store";

import styles from "./admin-tools.module.scss";

export type AdminToolsProps = {
  displaySettings: {
    showNotes: boolean;
    showPolicySearch: boolean;
    showUserInput: boolean;
  };
  setDisplaySettings: (
    update: Partial<AdminToolsProps["displaySettings"]>,
  ) => void;
};

export const AdminTools = ({
  displaySettings,
  setDisplaySettings,
}: AdminToolsProps) => {
  return (
    <div className={styles.adminToolsWrapper}>
      <Button
        icon="User"
        appearance={IS_IMPERSONATED ? "primary" : "tertiary"}
        destructive={IS_IMPERSONATED}
        onPress={() => {
          if (IS_IMPERSONATED) {
            const url = new URL(window.location.href);
            url.searchParams.delete("user");
            window.location.assign(url);
          } else {
            setDisplaySettings({
              showUserInput: true,
            });
          }
        }}
      />
      <Button
        icon="PolicyManagement"
        appearance="tertiary"
        onPress={() =>
          setDisplaySettings({
            showPolicySearch: !displaySettings.showPolicySearch,
          })
        }
      />
      <Button
        icon="Notes"
        appearance="tertiary"
        onPress={() => {
          setDisplaySettings({ showNotes: !displaySettings.showNotes });
        }}
      />
    </div>
  );
};
